import BUDGET_CONST, { SMART_DELIVERY_GOAL_APP_LIST, SMART_DELIVERY_GOAL_LIST } from '@/views/create/gdt/model/budget/budget-const.js'
import { SMART_DELIVERY_PLATFORM } from '../project-const'
import { BID_ADJUSTMENT_COEFFICIENT_TYPE, validateBidAdjustmentCoefficient, validateBidAdjustmentSiteSet } from './bid-adjustment.js'

// 整数或小数点两位，正则校验
export const twoDigit = /^[0-9]+([.]{1}[0-9]{1,2})?$/
export const threeDigit = /^[0-9]+([.]{1}[0-9]{1,3})?$/

function dailyBudgetValid(rule, value, callback) {
  let { budget, daily_budget, total_budget, bid_amount, bid_range, bid_num_range, old_daily_budget } = this.budgetForm

  const dailyBudget = Number(daily_budget)
  const totalBudget = Number(total_budget)
  console.log('budget output: ', budget)
  if (budget === 1) {
    if (!dailyBudget) {
      return callback(new Error('预算不能为空'))
    }

    // 保留2为小数
    if (!twoDigit.test(daily_budget)) {
      return callback(new Error('最多保留2位小数'))
    }

    if (totalBudget) {
      if (dailyBudget >= totalBudget) {
        return callback(new Error(`日预算须小于总预算${totalBudget}`))
      }
    }

    const increasement = dailyBudget - old_daily_budget

    if ((increasement > 0 && increasement < 50) || increasement < 0) {
      return callback(new Error('每次修改幅度不能低于50元'))
    }

    const [min, max] = bid_num_range || []
    bid_amount = bid_range ? Math.max(min, max) : Number(bid_amount)
    if (!Object.is(bid_amount, NaN) && bid_amount >= dailyBudget) {
      return callback(new Error('预算须大于出价'))
    }

    if (dailyBudget && !Object.is(dailyBudget, NaN) && dailyBudget >= 50 && dailyBudget <= 40000000) {
      callback()
    } else {
      callback(new Error('预算范围 50 ~ 40,000,000元'))
    }
  } else {
    // 不限预算
    callback()
  }
}

function totalBudgetValid(rule, value, callback) {
  const { totalBudget, total_budget, daily_budget } = this.budgetForm

  if (totalBudget === 1) {
    if (!total_budget) {
      return callback(new Error('总预算不能为空'))
    }

    const totalBudget = Number(total_budget)
    if (daily_budget && daily_budget >= totalBudget) {
      return callback(new Error('总预算须大于日预算'))
    }

    // 保留2为小数
    if (!twoDigit.test(total_budget)) {
      return callback(new Error('最多保留2位小数'))
    }

    if (totalBudget && !Object.is(totalBudget, NaN) && totalBudget >= 0 && totalBudget <= 200000000) {
      callback()
    } else {
      callback(new Error('预算范围 0 ~ 200,000,000元'))
    }
  } else {
    // 不限预算
    callback()
  }
}

const minValue = 0.1

function bidRangeValid(numRange) {
  if (!numRange?.length) {
    return '请输入出价'
  }

  const [min, max] = numRange.map((n) => Number(n))

  if (Object.is(min, NaN) || Object.is(max, NaN)) {
    return '请输入数字'
  }

  // 保留2为小数
  if (!twoDigit.test(numRange[0]) || !twoDigit.test(numRange[1])) {
    return '最多保留2位小数'
  }

  if (min >= max) {
    return '最小值不能大于等于最大值'
  }
  if (min < minValue || max < minValue) {
    return `最小值不能小于${minValue},最大值不能小于${minValue}`
  }
}

function bidValueValid(bidAmount) {
  const bidAmountValue = Number(bidAmount)

  if (!bidAmount) {
    return '请输入出价'
  }
  if (Object.is(bidAmountValue, NaN)) {
    return '请输入数字'
  }

  if (!twoDigit.test(String(bidAmount))) {
    return '最多保留2位小数'
  }

  if (bidAmountValue < minValue) {
    return `最小值不能小于${minValue}`
  }
  if (bidAmountValue > 10000) {
    return `最大值不能大于${10000}`
  }
}

function bidAmountValid(rule, value, callback) {
  const { bid_range, bid_amount, bid_num_range } = this.budgetForm

  if (bid_range) {
    const msg = bidRangeValid(bid_num_range)
    msg ? callback(new Error(msg)) : callback()
  } else {
    const msg = bidValueValid(bid_amount)
    msg ? callback(new Error(msg)) : callback()
  }
}

function deepBidAmountValid(rule, value, callback) {
  const { deep_bid_range, bid_amount, deep_deepbid_num_range } = this.budgetForm.deep_conversion_spec.deep_conversion_behavior_spec

  if (deep_bid_range) {
    const msg = bidRangeValid(deep_deepbid_num_range)
    msg ? callback(new Error(msg)) : callback()
  } else {
    const msg = bidValueValid(bid_amount)
    msg ? callback(new Error(msg)) : callback()
  }
}

function deepBidRoiValid(rule, value, callback) {
  const { expected_roi } = this.budgetForm.deep_conversion_spec.deep_conversion_worth_spec

  const expectedRoi = Number(expected_roi)

  if (Object.is(expectedRoi, NaN)) {
    return callback(new Error('请输入数字'))
  }

  // 保留3为小数
  if (!threeDigit.test(expected_roi)) {
    return callback(new Error('最多保留3位小数'))
  }

  if (expected_roi < 0.001 || expected_roi > 1000) {
    return callback(new Error('roi范围0.001 ~ 1000'))
  }

  callback()
}

function autoAcquisitionBudgetValid(rule, value, callback) {
  const { auto_acquisition_budget, auto_acquisition_enabled } = this.budgetForm
  if (auto_acquisition_enabled) {
    if (auto_acquisition_budget > 100000 || auto_acquisition_budget < 50) {
      return callback(new Error('预算不能大于100000，不能小于50'))
    }
    if (!twoDigit.test(auto_acquisition_budget)) {
      return callback(new Error('最多保留2位小数'))
    }
  }
  callback()
}

function customCostCapValid(rule, value, callback) {
  const { custom_cost_cap, cost_constraint_scene, bid_scene } = this.budgetForm
  if (bid_scene === BUDGET_CONST.BID_SCENE.NORMAL_MAX && cost_constraint_scene === BUDGET_CONST.COST_CONTROL.OPEN) {
    if (custom_cost_cap > 20000 || custom_cost_cap < 0) {
      return callback(new Error('成本上限值范围为0 ~ 20000 元'))
    }
    // 必须是整数
    // if (custom_cost_cap % 1 !== 0 || String(custom_cost_cap).includes('.')) {
    //   return callback(new Error('请输入整数'))
    // }
  }
  callback()
}

function registerCostValid(rule, value, callback) {
  const { register_cost } = this.budgetForm.smart_promotion_spec || {}

  if (!register_cost) {
    return callback(new Error('请输入注册成本'))
  }
  if (register_cost > 20000 || register_cost <= 0) {
    return callback(new Error('成本上限值范围为0.01 ~ 20000 元'))
  }
  if (!twoDigit.test(register_cost)) {
    return callback(new Error('最多保留2位小数'))
  }

  callback()
}

function multiOptimizationCostValid(rule, value, callback) {
  const field = rule.field.replace('version_smart_', '')
  const { bid_amount } = this.budgetForm[field] || {}

  if (!bid_amount) {
    return callback(new Error('请输入成本'))
  }
  if (bid_amount > 20000 || bid_amount <= 0) {
    return callback(new Error('成本上限值范围为1 ~ 20000 元'))
  }
  if (!Number.isInteger(Number(bid_amount))) {
    return callback(new Error('请输入整数'))
  }

  callback()
}

function multiOptPurchaseRoiValid(rule, value, callback) {
  const { deep_conversion_worth_rate } = this.budgetForm.game_app_activate_roi_spec
  if (!deep_conversion_worth_rate) {
    return callback(new Error('请输入值'))
  }
  if (deep_conversion_worth_rate > 50 || deep_conversion_worth_rate <= 0) {
    return callback(new Error('数值范围为0.001 ~ 50'))
  }
  if (!threeDigit.test(deep_conversion_worth_rate)) {
    return callback(new Error('请输入数字，最多保留3位小数'))
  }

  callback()
}

/**
 * @description: 智投小游戏「沉默唤起+首日付费ROI」的首日付费ROI校验
 */
function backFlowPurchaseRoiValid(rule, value, callback) {
  const { deep_conversion_worth_rate } = this.budgetForm.bid_amount_deep_conversion_worth_rate_spec || {}
  if (!deep_conversion_worth_rate) {
    return callback(new Error('请输入值'))
  }
  if (deep_conversion_worth_rate > 50 || deep_conversion_worth_rate <= 0) {
    return callback(new Error('数值范围为0.001 ~ 50'))
  }
  if (!threeDigit.test(deep_conversion_worth_rate)) {
    return callback(new Error('请输入数字，最多保留3位小数'))
  }

  callback()
}

function purchaseRoiValid({ field }, value, callback) {
  const { smart_promotion_spec } = this.budgetForm
  const val = smart_promotion_spec[field]
  if (!val) {
    return callback(new Error('请输入值'))
  }
  if (val > 50 || val <= 0) {
    return callback(new Error('数值范围为0.001 ~ 50'))
  }
  if (!threeDigit.test(val)) {
    return callback(new Error('请输入数字，最多保留3位小数'))
  }

  callback()
}

function smartDeliveryPlatformValid(rules, value, callback) {
  const { smart_delivery_platform } = this.planForm
  const { smart_delivery_goal } = this.budgetForm

  const appGameGoals = SMART_DELIVERY_GOAL_APP_LIST.map((g) => g.value)
  const miniGameGoals = SMART_DELIVERY_GOAL_LIST.map((g) => g.value)

  if (smart_delivery_platform === SMART_DELIVERY_PLATFORM.GAME_APP) {
    if (!appGameGoals.includes(smart_delivery_goal)) {
      return callback(new Error('请选择智投投放目标'))
    }
  }

  if (smart_delivery_platform === SMART_DELIVERY_PLATFORM.MINI_GAME_PROMOTION) {
    if (!miniGameGoals.includes(smart_delivery_goal)) {
      return callback(new Error('请选择智投投放目标'))
    }
  }

  callback()
}

function bidAdjustmentSiteSetValid(rule, value, callback) {
  const message = validateBidAdjustmentSiteSet(this.budgetForm)
  message ? callback(new Error(message)) : callback()
}

function bidAdjustmentCoefficientValid(type) {
  return function (rule, value, callback) {
    const message = validateBidAdjustmentCoefficient(this.budgetForm, type)
    message ? callback(new Error(message)) : callback()
  }
}

function makeRules() {
  return {
    // 日预算
    daily_budget: [{ validator: dailyBudgetValid.bind(this), trigger: 'blur' }],
    // 总预算
    total_budget: [{ validator: totalBudgetValid.bind(this), trigger: 'blur' }],
    // 出价
    bid_amount: [{ validator: bidAmountValid.bind(this), trigger: 'blur' }],
    deep_bid_amount: [{ validator: deepBidAmountValid.bind(this), trigger: 'blur' }],
    deep_roi: [{ validator: deepBidRoiValid.bind(this), trigger: 'blur' }],
    autoAcquisitionBudget: [{ validator: autoAcquisitionBudgetValid.bind(this), trigger: 'blur' }],

    // 控制成本
    custom_cost_cap: [{ validator: customCostCapValid.bind(this), trigger: 'change' }],

    smart_delivery_platform: [{ required: true, validator: smartDeliveryPlatformValid.bind(this), trigger: 'change' }],

    // 智投优选版位提价
    bid_adjustment_site_set: [{ validator: bidAdjustmentSiteSetValid.bind(this), trigger: 'change' }],
    bid_adjustment_shallow_coefficient: [
      { validator: bidAdjustmentCoefficientValid(BID_ADJUSTMENT_COEFFICIENT_TYPE.SHALLOW).bind(this), trigger: ['blur', 'change'] }
    ],
    bid_adjustment_deep_coefficient: [
      { validator: bidAdjustmentCoefficientValid(BID_ADJUSTMENT_COEFFICIENT_TYPE.DEEP).bind(this), trigger: ['blur', 'change'] }
    ],

    // 智投参数校验
    register_cost: [{ required: true, validator: registerCostValid.bind(this), trigger: 'blur' }],
    first_day_purchase_roi: [{ required: true, validator: purchaseRoiValid.bind(this), trigger: 'blur' }],
    seven_day_purchase_roi: [{ required: true, validator: purchaseRoiValid.bind(this), trigger: 'blur' }],
    day30_purchase_roi: [{ required: true, validator: purchaseRoiValid.bind(this), trigger: 'blur' }],
    iaap_roi: [{ required: true, validator: purchaseRoiValid.bind(this), trigger: 'blur' }],
    iaap_mix_in_one_factor: [{ required: true, validator: purchaseRoiValid.bind(this), trigger: 'blur' }],
    // 智投app游戏应用智投参数校验
    version_smart_game_app_activate_roi_spec: [{ required: true, validator: multiOptimizationCostValid.bind(this), trigger: 'blur' }],
    version_smart_bid_amount_spec: [{ required: true, validator: multiOptimizationCostValid.bind(this), trigger: 'blur' }],
    deep_conversion_worth_rate: [{ required: true, validator: multiOptPurchaseRoiValid.bind(this), trigger: 'blur' }],
    // 智投小游戏「沉默唤起+首日付费ROI」参数校验
    version_smart_bid_amount_deep_conversion_worth_rate_spec: [{ required: true, validator: multiOptimizationCostValid.bind(this), trigger: 'blur' }],
    back_flow_deep_conversion_worth_rate: [{ required: true, validator: backFlowPurchaseRoiValid.bind(this), trigger: 'blur' }]
  }
}

export default makeRules
